export const categories = [
  { id: 'love', name: '恋爱', slug: 'love', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事，感受心动瞬间', count: 128 },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '异世界冒险与魔法奇幻之旅', count: 96 },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-sword-line', description: '热血战斗与精彩对决', count: 87 },
  { id: 'suspense', name: '悬疑', slug: 'suspense', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理故事', count: 64 },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '轻松幽默，笑料不断的日常', count: 73 },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-film-line', description: '深刻动人的剧情故事', count: 92 },
  { id: 'horror', name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖漫画', count: 41 },
  { id: 'daily', name: '日常', slug: 'daily', icon: 'ri-sun-line', description: '温馨治愈的日常生活', count: 55 },
] as const;

export const allCategories = categories;